import React from 'react';
import PropTypes from 'prop-types';
import {BarChart} from 'charts';
import {getBarHeight, getGroupsForComparisons} from 'common/utils/chart-util';
import {ReportCardHeightTypeEnum} from 'common/proxies/enum-proxy';
import Card from 'common/components/card';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import './index.scss';

/**
 * ComparisonCard wraps the BarChart component, parsing the chart
 * groups from the report and adding a header and styling.
 */
const ComparisonCard = ({connectDragSource, disableConfig, report}) => {
  const {meta, scheduleId, warnings} = report;
  const groups = getGroupsForComparisons(report);

  const subtitle = meta.period ? meta.period.displayName : '';

  return (
    <Card className={'ComparisonCard'} loading={false}>
      {(connectDragSource || ((x) => x))(
        <div>
          <CardHeader
            disableConfig={disableConfig}
            priorityWarnings={report.priorityWarnings}
            reportId={report.id}
            scheduleId={scheduleId}
            subtitle={subtitle}
            title={report.name}
            warnings={warnings}
          />
        </div>,
      )}
      <CardContent>
        <BarChart
          barHeight={getBarHeight(meta.show_values)}
          groups={groups}
          height={
            meta.cardHeightType === ReportCardHeightTypeEnum.CUSTOM.id
              ? meta.cardHeight
              : null
          }
          showLegend={true}
          showTooltip={true}
        />
      </CardContent>
    </Card>
  );
};

ComparisonCard.propTypes = {
  connectDragSource: PropTypes.func,
  disableConfig: PropTypes.bool,
  report: PropTypes.object.isRequired,
};

ComparisonCard.defaultProps = {
  disableConfig: false,
  report: {},
};

export default ComparisonCard;
